import { useCallback } from "react";
import { useVisitorData } from "@fingerprintjs/fingerprintjs-pro-react";
import { useIsFingerprintEnabled } from "./OptionalFingerprintProvider";

export type FingerprintResult = {
  deviceId: string;
  deviceRequestId: string;
};

export type FingerprintDataType = {
  deviceId: string;
  deviceRequestId: string;
  error: Error | undefined;
  isEnabled: boolean;
  captureData: () => Promise<FingerprintResult>;
};

export const useFingerPrintData = (action: string): FingerprintDataType => {
  const isEnabled = useIsFingerprintEnabled();
  const { getData, data, error } = useVisitorData(
    { extendedResult: true, tag: { userAction: action } },
    { immediate: isEnabled }
  );

  const captureData = useCallback(async (): Promise<FingerprintResult> => {
    if (!isEnabled) {
      return { deviceId: "", deviceRequestId: "" };
    }

    try {
      const result = await getData();
      return {
        deviceId: result.visitorId,
        deviceRequestId: result.requestId,
      };
    } catch (err) {
      console.warn("Fingerprint collection failed:", err);
      return { deviceId: "", deviceRequestId: "" };
    }
  }, [getData, isEnabled]);

  return {
    deviceId: data?.visitorId ?? "",
    deviceRequestId: data?.requestId ?? "",
    error,
    isEnabled,
    captureData,
  };
};
